// src/pages/Dashboard.jsx - COMPACT VERSION WITHOUT STATS
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Dashboard = () => {
  const [showComingSoonModal, setShowComingSoonModal] = useState(false);
  const navigate = useNavigate();

  const services = [   
    {
      title: 'Latest in Law',
      description: 'Stay updated with fresh judgments, amendments, legal daily news and other legal developments on a daily basis.',
      icon: '/Images/i-law.png',
      link: '/Latest-Law',
      color: '#E91E63'
    },
    {
      title: 'Database',
      description: 'Access comprehensive legal database with instant answers to legal questions and document research.',
      icon: '/Images/i-database.png',
      link: '/database',
      color: '#E91E63'
    },
    {
      title: 'Keyword Search',
      description: 'Get instant, precise results using exact phrase, free word, all words, and near-word matching.',
      icon: '/Images/i-case-law-research-04.png',
      link: '/keyword',
      color: '#E91E63'
    },
    {
      title: 'Citation Search',
      description: 'Quickly find Indian case laws using journal name, year, volume, and page. Supports all courts.',
      icon: '/Images/i-Citation Search-05.png',
      link: '/citation',
      color: '#E91E63'
    },
    {
      title: 'Advanced Search',
      description: 'Find case laws by keywords, party names, judges, or case numbers across all courts.',
      icon: '/Images/i-Advance Case Law Search-06.png',
      link: '/search',
      color: '#E91E63'
    },
    {
      title: 'Nominal Search',
      description: 'Locate cases by petitioner/respondent names—fast and accurate search results.',
      icon: '/Images/NominalSearch.png',
      link: '/Nominal',
      color: '#E91E63'
    },
    
    {
      title: 'Bookmarks',
      description: 'Save important judgments instantly with the Bookmark feature for quick future access.',
      icon: '/Images/bookmark.png',
      link: '/saveBookmarks',
      color: '#E91E63'
    },
    {
  title: 'Judge / Advocate Search',
  description: 'Search judgments by judge or advocate name—fast and accurate results across all courts.',
  icon: '/Images/NominalSearch.png',   // reuse person icon, or add a new one
  link: '/judge',
  color: '#E91E63'
},
{
  title: 'Act Wise Search',
  description: 'Search judgments by Act name and Section number across all Indian courts instantly.',
  icon: '/Images/i-law.png',           // reuse law icon, or add a new one
  link: '/act-search',
  color: '#E91E63'
},
    // {
    //   title: 'Legal Dictionary',
    //   description: 'Comprehensive legal terminology at your fingertips for precise legal research.',
    //   icon: '/Images/legaldictionary.png',
    //   link: '/Dictionary',
    //   color: '#ffecd2'
    // },
    // {
    //   title: 'Reports',
    //   description: 'Covers Law Commission Reports, Constituent Assembly Debates and other important legal reports.',
    //   icon: '/Images/reports.png',
    //   link: '/Reports',
    //   color: '#a1c4fd'
    // },
    // {
    //   title: 'Central Laws',
    //   description: 'A comprehensive library of all Central Statutes and regulations, providing quick access to authoritative legal texts.',
    //   icon: '/Images/centrallaws.png',
    //   link: '/CAActsList',
    //   color: '#d4fc79'
    // },
    // {
    //   title: 'State Laws',
    //   description: 'A dedicated collection of state-specific statutes and regulations, enabling quick reference to region-wise legal provisions.',
    //   icon: '/Images/statelaw.png',
    //   link: 'state-Law',
    //   color: '#fbc2eb'
    // },
    // {
    //   title: 'Articles & Blogs',
    //   description: 'Handpicked, expertly written legal articles and blogs by eminent authors—reliable insights you can cite and trust.',
    //   icon: '/Images/articles_ic.png',
    //   link: '/articles',
    //   color: '#fdcbf1'
    // },
    // {
    //   title: 'Virtual Legal Assistant',
    //   description: 'Get instant answers to legal questions, draft documents, and streamline your workflow.',
    //   icon: '/Images/i-Virtual Legal Assistant-07.png',
    //   link: '#virtual-legal-assistant',
    //   color: '#e0c3fc'
    // }
  ];

  return (
    <div className="modern-dashboard">
      {/* Compact Hero Section */}
      <div className="dashboard-hero">
        <div className="hero-content">
          <h1 className="hero-title">
            Welcome to <span className="gradient-text">LJSoft Online</span>
          </h1>
         
        </div>
        
        <div className="hero-decoration">
          <div className="float-circle circle-1"></div>
          <div className="float-circle circle-2"></div>
        </div>
      </div>

      {/* Services Section */}
      <div className="services-container">
        <div className="section-header">
          <h2 className="section-title">Explore Our Services</h2>
          
        </div>

        <div className="services-grid">
          {services.map((service, index) => {
            const isExternalLink = service.link.startsWith('#');

            if (isExternalLink) {
  return (
    <a
      key={index}
      href={service.link}
      className="service-card"
      onClick={(e) => {
        e.preventDefault();
        setShowComingSoonModal(true);
      }}
    >
      <div
        className="card-glow"
        style={{
          background: `linear-gradient(135deg, ${service.color}40, ${service.color}10)`
        }}
      ></div>

      <div className="service-icon-wrapper">
        <img
          src={service.icon}
          alt={service.title}
          className="service-icon-img"
          onError={(e) => {
            e.target.style.display = 'none';
            e.target.parentElement.innerHTML =
              '<i class="bx bx-file" style="font-size:48px;color:#E91E63;"></i>';
          }}
        />
      </div>

      <div className="service-info">
        <h3 className="service-name">{service.title}</h3>
        <p className="service-desc">{service.description}</p>
      </div>

      <div className="service-arrow">
        <i className="bx bx-right-arrow-alt"></i>
      </div>
    </a>
  );
}


            return (
              <Link
                key={index}
                to={service.link === "state-Law" ? "#" : service.link}
                className="service-card"
                onClick={(e) => {
                  if (service.link === "state-Law") {
                    e.preventDefault();
                    navigate(`/StateLaws`);
                  }
                }}
              >
                <div className="card-glow" style={{ background: `linear-gradient(135deg, ${service.color}40, ${service.color}10)` }}></div>
                
                <div className="service-icon-wrapper">
                  <img
                    src={service.icon}
                    alt={service.title}
                    className="service-icon-img"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.parentElement.innerHTML = '<i class="bx bx-file" style="font-size: 48px; color: #E91E63;"></i>';
                    }}
                  />
                </div>

                <div className="service-info">
                  <h3 className="service-name">{service.title}</h3>
                  <p className="service-desc">{service.description}</p>
                </div>

                <div className="service-arrow">
                  <i className="bx bx-right-arrow-alt"></i>
                </div>
              </Link>
            );
          })}
        </div>
      </div>

      {/* Compact Footer */}
      <div className="dashboard-footer">
        <p className="footer-text">
          LJSoft Online specializes in advanced legal research tools, ensuring compliance with all legal and ethical standards.
        </p>
      </div>

      {/* Coming Soon Modal */}
      {showComingSoonModal && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 9999 }}
          onClick={() => setShowComingSoonModal(false)}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content" style={{
              borderRadius: '16px',
              border: 'none',
              boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)'
            }}>
              <div className="modal-header border-0">
                <h5 className="modal-title" style={{
                  fontSize: '24px',
                  fontWeight: '700',
                  background: 'linear-gradient(135deg, #E91E63 0%, #c41849 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent'
                }}>
                  Coming Soon
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowComingSoonModal(false)}
                ></button>
              </div>
              <div className="modal-body text-center py-4">
                <div style={{
                  fontSize: '48px',
                  background: 'linear-gradient(135deg, #E91E63 0%, #c41849 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  marginBottom: '16px'
                }}>
                  <i className="bx bx-time-five"></i>
                </div>
                <p style={{ fontSize: '16px', color: '#6b7280', marginBottom: '0' }}>
                  This feature is currently under development and will be available soon!
                </p>
              </div>
              <div className="modal-footer border-0">
                <button
                  type="button"
                  className="btn btn-primary w-100"
                  onClick={() => setShowComingSoonModal(false)}
                  style={{
                    borderRadius: '8px',
                    background: 'linear-gradient(135deg, #E91E63 0%, #c41849 100%)',
                    border: 'none',
                    padding: '12px',
                    fontWeight: '600'
                  }}
                >
                  Got it!
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        /* Modern Dashboard - Compact Version */
        .modern-dashboard {
          min-height: 100vh;
          background: #fafafa;
        }

        /* Compact Hero Section */
        .dashboard-hero {
          position: relative;
          background: linear-gradient(135deg, #E91E63 0%, #E91E64 50%, #c41849 100%);
          padding: 60px 20px;
          text-align: center;
          overflow: hidden;
          z-index: 1;
        }

        .hero-content {
          position: relative;
          z-index: 2;
          max-width: 800px;
          margin: 0 auto;
        }

        .hero-title {
          font-size: clamp(2rem, 4vw, 3rem);
          font-weight: 800;
          color: white;
          margin-bottom: 16px;
          line-height: 1.2;
        }

        .gradient-text {
          display: inline-block;
          background: linear-gradient(135deg, #ffffff 0%, #f8f8f8 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .hero-subtitle {
          font-size: clamp(0.95rem, 2vw, 1.1rem);
          color: rgba(255, 255, 255, 0.95);
          max-width: 600px;
          margin: 0 auto;
          line-height: 1.6;
        }

        .hero-decoration {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          overflow: hidden;
          z-index: 1;
          pointer-events: none;
        }

        .float-circle {
          position: absolute;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.1);
        }

        .circle-1 {
          width: 300px;
          height: 300px;
          top: -100px;
          right: -80px;
          animation: float 20s infinite ease-in-out;
        }

        .circle-2 {
          width: 200px;
          height: 200px;
          bottom: -50px;
          left: -50px;
          animation: float 25s infinite ease-in-out reverse;
        }

        @keyframes float {
          0%, 100% { transform: translate(0, 0) scale(1); }
          50% { transform: translate(-20px, -20px) scale(1.1); }
        }

        /* Services Container */
        .services-container {
          max-width: 1400px;
          margin: 0 auto;
          padding: 50px 20px;
          position: relative;
          z-index: 10;
        }

        .section-header {
          text-align: center;
          margin-bottom: 40px;
        }

        .section-title {
          font-size: clamp(1.8rem, 4vw, 2.5rem);
          font-weight: 800;
          background: linear-gradient(135deg, #E91E63 0%, #c41849 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          margin-bottom: 12px;
        }

        .section-description {
          font-size: 1.05rem;
          color: #6b7280;
          max-width: 600px;
          margin: 0 auto;
          line-height: 1.5;
        }

        /* Services Grid - Compact Horizontal Layout */
.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 20px;
}

.service-card {
  position: relative;
  text-decoration: none;
  display: flex;
  flex-direction: row;  /* Changed from column to row */
  align-items: center;   /* Center items vertically */
  gap: 16px;            /* Space between icon and content */
  background: white;
  border-radius: 12px;
  padding: 16px 20px;   /* Reduced padding */
  transition: all 0.3s ease;
  overflow: hidden;
  border: 1px solid #f0f0f0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  min-height: 90px;     /* Compact height */
}

.service-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #E91E63 0%, #c41849 100%);
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.3s ease;
}

.service-card:hover::before {
  transform: scaleX(1);
}

.card-glow {
   position: absolute;
    inset: 0;
    opacity: 1;
}

.service-card:hover .card-glow {
  opacity: 1;
}

.service-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(245, 166, 35, 0.12);
  border-color: rgba(245, 166, 35, 0.3);
}

.service-icon-wrapper {
  width: 56px;          /* Reduced size */
  height: 56px;         /* Reduced size */
  flex-shrink: 0;       /* Prevent icon from shrinking */
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(245, 166, 35, 0.1), rgba(233, 30, 99, 0.1));
  border-radius: 12px;
  transition: all 0.3s ease;
  margin-bottom: 0;     /* Remove bottom margin */
}

.service-card:hover .service-icon-wrapper {
  transform: scale(1.05) rotate(2deg);
  background: linear-gradient(135deg, rgba(245, 166, 35, 0.15), rgba(233, 30, 99, 0.15));
}

.service-icon-img {
  width: 36px;
  height: 36px;
  object-fit: contain;
  // filter: brightness(0) saturate(100%) invert(72%) sepia(82%) saturate(800%) hue-rotate(10deg) brightness(102%);
  transition: filter 0.3s ease;
}

.service-info {
  flex: 1;              /* Take remaining space */
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;         /* Allow text truncation */
}

.service-name {
  font-size: 1.05rem;   /* Slightly smaller */
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 4px;   /* Reduced spacing */
  line-height: 1.3;
  transition: color 0.3s ease;
}

.service-card:hover .service-name {
  background: linear-gradient(135deg, #E91E63 0%, #c41849 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.service-desc {
  color: #6b7280;
  line-height: 1.4;     /* Reduced line height */
  margin: 0;
  font-size: 0.85rem;   /* Smaller description */
  display: -webkit-box;
  -webkit-line-clamp: 2; /* Limit to 2 lines */
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.service-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;     /* Space from content */
  flex-shrink: 0;
}

.service-arrow i {
  font-size: 20px;      /* Slightly smaller arrow */
  color: #d1d5db;
  transition: all 0.3s ease;
}

.service-card:hover .service-arrow i {
  color: #E91E63;
  transform: translateX(4px);
}

/* Responsive Design */
@media (max-width: 768px) {
  .services-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .service-card {
    padding: 14px 16px;
    min-height: 80px;
  }

  .service-icon-wrapper {
    width: 48px;
    height: 48px;
  }

  .service-icon-img {
    width: 30px;
    height: 30px;
  }

  .service-name {
    font-size: 0.95rem;
  }

  .service-desc {
    font-size: 0.8rem;
  }
}

@media (max-width: 480px) {
  .service-card {
    gap: 12px;
  }
}

        
        /* Compact Footer */
        .dashboard-footer {
          max-width: 900px;
          margin: 40px auto 0;
          padding: 30px 20px;
          text-align: center;
          border-top: 1px solid #e5e7eb;
        }

        .footer-text {
          font-size: 0.95rem;
          color: #6b7280;
          margin: 0;
          line-height: 1.6;
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .dashboard-hero {
            padding: 50px 20px;
          }

          .services-container {
            padding: 40px 20px;
          }

          .section-header {
            margin-bottom: 30px;
          }

         
        }

        @media (max-width: 480px) {
          .hero-title {
            font-size: 1.8rem;
          }

          .section-title {
            font-size: 1.6rem;
          }
        }

         /* ============================================
           REMOVE TOP WHITE SPACE
        ============================================ */
        body {
          margin: 0 !important;
          padding: 0 !important;
        }
      `}</style>
    </div>
  );
};

export default Dashboard;